import { NavLink, useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import Cookies from "universal-cookie";

import home_logo from "../assets/nav-bar-icons/home-logo.svg";
import shipments_logo from "../assets/nav-bar-icons/shipments-logo.svg";
import billing_logo from "../assets/nav-bar-icons/billing-logo.svg";
import reports_logo from "../assets/nav-bar-icons/reports-logo.svg";
import settings_logo from "../assets/nav-bar-icons/settings-logo.svg";

import "../stylesheets/Sidebar.scss";
import { TbLogout } from "react-icons/tb";
import { HiUsers } from "react-icons/hi";
import Tooltip from "./common/Tooltip.jsx";
import { FaEllipsisH } from "react-icons/fa";

import { toast } from "react-toastify";
import { loadingAnimation } from "./scripts/functions";

const Sidebar = () => {
  const cookies = new Cookies();
  const token = cookies.get("token_user");
  const [role, setRole] = useState(null); // number

  const tooltipToggleRef = useRef(null);

  const navLinkStyles = ({ isActive }) => ({
    opacity: isActive ? "1" : ".5",
  });

  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }
    // Normalize role to number (cookie is usually a string)
    const roleFromCookie = Number(cookies.get("role_user"));
    setRole(Number.isNaN(roleFromCookie) ? null : roleFromCookie);
  }, []);

  useEffect(() => {
    if (!token) {
      navigate("/login");
    }
  }, [cookies, token, navigate]);

  const [actTooltip, setActTooltip] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const URL = process.env.REACT_APP_API_URL + "/user";
  const logout = async () => {
    try {
      loadingAnimation(true);
      const resp = await fetch(`${URL}/logout`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
      });
      await resp.json().catch(() => ({}));
      loadingAnimation(false);
      if (resp?.status === 200) {
        cookies.remove("token_user", { path: "/" });
        cookies.remove("name_user", { path: "/" });
        cookies.remove("role_user", { path: "/" });
        navigate("/login");
      } else {
        toast.error("Something went wrong. Please, try again in a few minutes!");
      }
    } catch {
      loadingAnimation(false);
      toast.error("Something went wrong. Please, try again in a few minutes!");
    }
  };

  useEffect(() => {
    const setByWidth = () => setIsMobile(window.innerWidth < 600);
    setByWidth();
    window.addEventListener("resize", setByWidth);
    return () => window.removeEventListener("resize", setByWidth);
  }, []);

  useEffect(() => {
    const navBarTooltipListener = (e, element) => {
      if (element.current && !element.current.contains(e.target)) {
        const tooltip = element?.current.querySelector(".custom-tooltip-container");
        if (tooltip?.classList.contains("active-tooltip")) {
          setActTooltip(false);
        }
      }
    };
    const handler = (e) => navBarTooltipListener(e, tooltipToggleRef);
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const isShipmentsOnly = role === 11;

  return (
    <aside className="navbar">
      <img
        src={require("../assets/atlantic-main-logo.png")}
        alt="main-logo"
        id="nav-bar_main-img"
      />
      <ul>
        {/* If shipments-only, either hide Home or point it to /shipments.
            Here we hide it entirely. */}
        {!isShipmentsOnly && (
          <li className="navbar-link">
            <NavLink to="/" style={navLinkStyles}>
              <img src={home_logo} alt="home" id="home-logo" className="nav-logo" />
            </NavLink>
          </li>
        )}

        {/* Shipments (always visible) */}
        <li className="navbar-link">
          <NavLink to="/shipments" style={navLinkStyles}>
            <img
              src={shipments_logo}
              alt="shipments"
              id="shipments-logo"
              className="nav-logo"
            />
          </NavLink>
        </li>

        {/* Hide Billing entirely for shipments-only */}
        {!isShipmentsOnly && (
          <li className="navbar-link">
            <NavLink to="/billing" style={navLinkStyles}>
              <img
                src={billing_logo}
                alt="billing"
                id="billing-logo"
                className="nav-logo"
              />
            </NavLink>
          </li>
        )}

        {/* Users: show only if NOT role 5 and NOT shipments-only */}
        {!isShipmentsOnly && role !== 5 && (
          <li className={`navbar-link ${isMobile ? "no-display" : ""}`}>
            <NavLink to="/users" style={navLinkStyles}>
              <HiUsers />
            </NavLink>
          </li>
        )}

        {/* Reports: temporarily hidden */}
        
        {!isShipmentsOnly && (
          <li className={`navbar-link ${isMobile ? "no-display" : ""}`}>
            <NavLink to="/settings" style={navLinkStyles}>
              <img
                src={settings_logo}
                alt="settings"
                id="settings-logo"
                className="nav-logo"
              />
            </NavLink>
          </li>
        )}

        {/* Mobile overflow menu: hide extra actions for shipments-only */}
        {isMobile && !isShipmentsOnly && (
          <li
            ref={tooltipToggleRef}
            className="navbar-link p-relative"
            onClick={() => setActTooltip((v) => !v)}
          >
            <a className="logout-btn">
              <FaEllipsisH />
            </a>

            <Tooltip
              myComponents={[
                role !== 5 ? (
                  <NavLink key="users" to="/users" style={navLinkStyles}>
                    <HiUsers />
                  </NavLink>
                ) : (
                  ""
                ),
                <NavLink key="settings" to="/settings" style={navLinkStyles}>
                  <img
                    src={settings_logo}
                    alt="settings"
                    id="settings-logo"
                    className="nav-logo"
                  />
                </NavLink>,
              ].filter(Boolean)}
              activeTooltip={actTooltip}
            />
          </li>
        )}

        <li className="navbar-link">
          <a className="logout-btn" onClick={logout}>
            <TbLogout />
          </a>
        </li>
      </ul>
    </aside>
  );
};
export default Sidebar;
